import axios from "axios";
import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface getOrgDraftRequest {
  userId: number;
  token: string;
}

const getOrgDraft = async ({ userId, token }: getOrgDraftRequest) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/trade-directory/organization/get-org-draft/${userId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    (error as Error).message = message;
    throw error;
  }
};

export default getOrgDraft;
